import { RichTextEditorComponent } from '@/global/rich-text-editor.component';
import { ApprovalsService } from '@/services/api/approvals.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { CommonModule } from '@angular/common';
import { Component, effect, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { Subscription } from 'rxjs';
import { ApprovalRequest } from 'src/app/models/approval.model';

@Component({
    selector: 'app-approval-form',
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        ToggleSwitchModule,
        RichTextEditorComponent
    ],
    template: `
<div class="flex gap-5 flex-column-reverse md:flex-row">
                <div class="flex-auto p-fluid">
                    <div class="mb-4">
                        <label for="approved" class="block font-medium text-900 mb-2">Approved</label>
                        <p-toggleswitch id="approved" [(ngModel)]="approval" />
                    </div>
                    <div class="mb-4">
                        <label for="bio" class="block font-medium text-900 mb-2">Message</label>
                        <app-rich-text-editor [(ngModel)]="message"></app-rich-text-editor>
                    </div>
            </div>
        </div>

        <div class="surface-card d-flex text-black footer-buttons border-round">
            <div class="info-action-row">
              <div class="info ml-2 md:mr-2">
                
              </div>
              <div class="action-row" > <!-- This container will hold all action items -->
                <div  class="action-item">
                  <p-button [icon]="approval ? 'pi pi-check' : 'pi pi-times'" 
                  [rounded]="false" 
                  [label]="'Send Response'" 
                  (click)="onRespond($event)">
                </p-button>
                </div>
              </div>
            </div>
          </div>
    `,
    styles: `
    .footer-buttons {
  position: sticky;
  bottom: 0;
  padding: 1em;
}

.changes {
  text-align: left !important;
}

.clientImage {
  height: 50px;
  width: auto;
}

.container {
  margin: 1px;
  padding: 0px;
}

.card {
  margin: 4px;
  padding-top: 4px;
}

.conTab {
  padding: 0px;
}

.conTable {
  padding: 0px;
}

#conIcon {
  margin-left: 0px;
  width: 40px;
  padding: 0px;
}

.info-action-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info {
  display: flex;
  flex-direction: column;
  align-items: top;
}

.name,
.role {
  margin-right: 5px;
}

.action-row {
  display: flex;
  justify-content: flex-end;
}

.action-item {
  margin-right: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  ;
}
    `,
    standalone: true
})
export class ApprovalFormComponent {
  message: string = '';
  approval: boolean = false;
  currentApprovalRequest!: ApprovalRequest;

  constructor(
    private approvalService: ApprovalsService,
    private binderDialogService: BinderDialogService,
    private messageService: MessageService
  ) { 
    effect(() => {
      const request = this.approvalService.currentRequest();
      if (request) {
        this.currentApprovalRequest = request;
      }
    });
  }


  onRespond(event: any) {
    const response = {
      approved: this.approval,
      message: this.message,
      approvalId: this.currentApprovalRequest.approvalId
    }
    console.log('responding to approval:', response);
    this.approvalService.respondToApproval(response).subscribe(res => {
      const projectStatus = response.approved ? 6 : 2;
      this.approvalService.setRequest(res, projectStatus);
      this.messageService.add({severity:'success', summary: 'Success', detail: 'Approval responded', life: 3000});
      this.binderDialogService.closeDialog();
      },
      error => {
        console.error('Error responding to approval:', error);
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Error responding to approval', life: 3000});
      }
    );

    }

}
